import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  current,
} from "@reduxjs/toolkit";
import {LOAI_PHIEU_KHO, TT_PHIEU_KHO, LOAI_FORM} from "types/enums";

export interface State {
  listLoOfName: any[];
  listUnitOfThuocId: any[];
  soLo_KhoId: any[];
  khoXuatId: any;
  khoNhapId: any;
  listThuocByName: any[];
  listLoByThuoc_Kho: any[];
}

const initialState: State = {
  listLoOfName: [],
  listUnitOfThuocId: [],
  soLo_KhoId: [],
  khoXuatId: null,
  khoNhapId: null,
  listThuocByName: [],
  listLoByThuoc_Kho: [],
};
const filterListById = (list: any[]) => {};

export const tableAddSlice = createSlice({
  name: "tableAdd",
  initialState: initialState,
  reducers: {
    setListLoOfName: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listLoOfName: [...state.listLoOfName, action.payload]};
    },
    setKhoXuatId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, khoXuatId: action.payload};
    },
    setKhoNhapId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, khoNhapId: action.payload};
    },
    setListThuocByName: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listThuocByName: action.payload};
    },
    setListLoByThuoc_Kho: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, listLoByThuoc_Kho: action.payload};
    },
    setListUnitOfThuocId: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        listUnitOfThuocId: [...state.listUnitOfThuocId, action.payload],
      };
    },
  },
});

export const {
  setListLoOfName,
  setListUnitOfThuocId,
  setKhoNhapId,
  setKhoXuatId,
  setListThuocByName,
} = tableAddSlice.actions;

export default tableAddSlice.reducer;
